import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import { recoverPasswordSendCode } from "../../redux/actions/session";

import logo from "../../assets/images/logo-trucoxo.png";

import "../login/Login.scss";

const EsqueciSenha = () => {
  const token = useSelector((state) => state.session.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      return toast.error("Por favor, preencha o campo de e-mail.");
    }
    dispatch(recoverPasswordSendCode(email));
  };

  if (token) return null;

  return (
    <div className="login-page">
      <button
        type="button"
        className="login-page__close"
        onClick={() => navigate("/")}
        aria-label="Fechar"
      >
        <i className="fa-solid fa-xmark" /> Fechar
      </button>

      <form className="login-card" onSubmit={handleSubmit} noValidate>
        <div className="login-card__brand">
          <img src={logo} alt="Truco XP" />
        </div>

        <header className="login-card__header">
          <h1>Esqueci minha senha</h1>
          <p>Enviaremos um link por e-mail para redefinir a sua senha</p>
        </header>

        <label className="login-field">
          <span className="login-field__label">E-mail</span>
          <input
            type="email"
            className="login-field__input"
            placeholder="Digite seu e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
        </label>

        <button type="submit" className="login-submit" disabled={!email}>
          Enviar por e-mail
        </button>

        <Link to="/login" className="login-card__signup-link">
          Lembrei minha senha
        </Link>
      </form>
    </div>
  );
};

export default EsqueciSenha;
